import { EnvironmentReading, PlantSceneResponse, ProcessUnit } from '@/types';
import { apiClient } from '../client';

export async function getPlantScene(): Promise<PlantSceneResponse> {
  const { data } = await apiClient.get<PlantSceneResponse>('/plant/scene');
  return data;
}

export async function getEnvironment(): Promise<EnvironmentReading> {
  const { data } = await apiClient.get<EnvironmentReading>('/plant/environment');
  return data;
}

/** Admin only — rename a tank's display name and/or tag/code. */
export async function renameUnit(id: string, name: string, tag: string): Promise<ProcessUnit> {
  const { data } = await apiClient.patch<ProcessUnit>(`/plant/units/${id}`, { name, tag });
  return data;
}
